import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import * as d3 from "d3";
import { format } from "date-fns";
import { formatHours } from "@/utils/duration";
export function WeeklyHoursBars({ data }) {
    const ref = useRef(null);
    useEffect(() => {
        if (!ref.current)
            return;
        const svg = d3.select(ref.current);
        svg.selectAll("*").remove();
        const width = 560;
        const height = 200;
        const margin = { top: 10, right: 8, bottom: 28, left: 32 };
        const x = d3
            .scaleBand()
            .domain(data.map((d) => d.date))
            .range([margin.left, width - margin.right])
            .padding(0.35);
        const yMax = Math.max(8, d3.max(data, (d) => d.hours) ?? 0);
        const y = d3.scaleLinear().domain([0, yMax]).nice().range([height - margin.bottom, margin.top]);
        const root = svg.attr("viewBox", `0 0 ${width} ${height}`);
        // Y gridlines
        root
            .append("g")
            .attr("class", "axis")
            .attr("transform", `translate(${margin.left},0)`)
            .call(d3
            .axisLeft(y)
            .ticks(4)
            .tickSize(-(width - margin.left - margin.right))
            .tickFormat((d) => `${d}h`))
            .call((g) => g.select(".domain").remove())
            .call((g) => g
            .selectAll("line")
            .attr("stroke", "#E2E8F0")
            .attr("stroke-dasharray", "2 3"));
        // X axis
        root
            .append("g")
            .attr("class", "axis")
            .attr("transform", `translate(0,${height - margin.bottom})`)
            .call(d3.axisBottom(x).tickFormat((d) => format(d, "EEE")))
            .call((g) => g.select(".domain").remove())
            .call((g) => g.selectAll("line").remove());
        // Bars
        root
            .append("g")
            .selectAll("rect")
            .data(data)
            .enter()
            .append("rect")
            .attr("x", (d) => x(d.date))
            .attr("y", (d) => y(d.hours))
            .attr("width", x.bandwidth())
            .attr("height", (d) => y(0) - y(d.hours))
            .attr("rx", 6)
            .attr("fill", "url(#weeklyBar)")
            .append("title")
            .text((d) => `${format(d.date, "EEE d MMM")} — ${formatHours(d.hours)}h`);
        // Gradient defs
        const defs = root.append("defs");
        const grad = defs
            .append("linearGradient")
            .attr("id", "weeklyBar")
            .attr("x1", "0")
            .attr("y1", "0")
            .attr("x2", "0")
            .attr("y2", "1");
        grad.append("stop").attr("offset", "0%").attr("stop-color", "#2563EB");
        grad.append("stop").attr("offset", "100%").attr("stop-color", "#38BDF8");
    }, [data]);
    return _jsx("svg", { ref: ref, className: "w-full h-[200px]" });
}
